export const LPT3000RX4 = {
  DEFAULT_PORT: '5025',
  RBW_VALUES: [
    'AUTO',
    '1 MHz',
    '300 kHz',
    '100 kHz',
    '30 kHz',
    '10 kHz',
    '3 kHz',
    '1 kHz',
    '300 Hz',
    '100 Hz',
    '30 Hz',
    '10 Hz',
    '3 Hz',
    '1 Hz',
  ],
  VBW_VALUES: [
    'AUTO',
    '1 MHz',
    '300 kHz',
    '100 kHz',
    '30 kHz',
    '10 kHz',
    '3 kHz',
    '1 kHz',
    '300 Hz',
    '100 Hz',
    '30 Hz',
    '10 Hz',
    '3 Hz',
    '1 Hz',
  ],
  PREAMP_VALUES: ['BYPASS', 'AUTO'],
  ATTEN_VALUES: ['AUTO', '0 dB', '10 dB', '20 dB', '30 dB', '40 dB', '50 dB'],
  SWEEP_TIME_ENABLED: true,
  DETECTION_MODE_VALUES: [
    'Normal',
    'Sample',
    'Positive',
    'Negative',
    'Average',
  ],
  IMAGES: {
    connected: 'unit-rx4-connected.png',
    disconnected: 'unit-rx4-disconnected.png',
    lostConnection: 'unit-rx4-lostconnection.png',
  },
  parseIdnResponse: (idnResponse: string) => {
    const splitResponse = idnResponse.split(',');

    return {
      model: splitResponse[1],
      serial: splitResponse[2],
    };
  },
};
